module.exports = __webpack_public_path__ + "assetsclientes/img/1.e2938115.png";